import { render, staticRenderFns } from "./show.vue?vue&type=template&id=aa0981b0&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa0981b0')) {
      api.createRecord('aa0981b0', component.options)
    } else {
      api.reload('aa0981b0', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=aa0981b0&", function () {
      api.rerender('aa0981b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configurator/show.vue"
export default component.exports